angular.module('autoremind.dashboard.directives')
    .directive('oneNumber', ['$location', function ($location) {
        return {
            templateUrl: 'app/dashboard/widgets/one-number.html',
            restrict: 'EA',
            scope: {
                value: '=',
                text: '=',
                reportType: '='
            },
            link: function (scope, elem, attr) {
                scope.openReport = function () {
                    console.log('Widget open - type ', scope.reportType);
                    switch (scope.reportType) {
                        case 'birthday':
                            $location.path('/reports/messaging').search({ type: scope.reportType });
                            break;
                        case 'recalls':
                            $location.path('/reports/recalls');
                            break;
                        case 'missed':
                            $location.path('/reports/missed');
                            break;
                        default:
                            $location.path('/reports/messaging');
                    }
                };
                scope.$watch('value', function () {
                    console.log('DEBUG: oneNumber directive ', angular.element(elem).find('.widgetText span'));
                });
                /**
                 * Filter that returns the class name suitable for the size of the number.
                 * If less than 4 digits then use biggest font, 5 digits then use medium and more digits then use smallest
                 */
                scope.getDigitsClass = function (value) {
                    if (!value)
                        return 'big-numbers';
                    value = parseInt(value);
                    if (value < 10000)
                        return 'big-numbers';
                    if (value < 100000 && value >= 10000)
                        return 'medium-numbers';
                    if (value >= 100000)
                        return 'small-numbers';
                };
            }
        };
    }]);
//# sourceMappingURL=one-number.directive.js.map